import { render, staticRenderFns } from "./CustomerDebtList.vue?vue&type=template&id=41a23842&scoped=true&lang=pug"
import script from "./CustomerDebtList.vue?vue&type=script&lang=js"
export * from "./CustomerDebtList.vue?vue&type=script&lang=js"
import style0 from "./CustomerDebtList.vue?vue&type=style&index=0&id=41a23842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a23842",
  null
  
)

export default component.exports